<template>
  <div>
    <button
      type="button"
      class="btn btn--secondary feedback-btn"
      @click="toggleModal"
    >
      {{
        rating && rating.confirmed ? 'Review your rating' : 'Rate this course'
      }}
    </button>
    <FeedbackModal v-if="modalOpened" @close-modal="toggleModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FeedbackModal from '@/components/modals/FeedbackModal.vue'

export default {
  name: 'CourseFeedback',
  components: {
    FeedbackModal,
  },
  computed: {
    ...mapState({
      rating: state => state.courses.courseRating,
      modalOpened: state => state.courses.courseRatingModalOpened,
    }),
  },
  methods: {
    toggleModal() {
      this.$store.dispatch('courses/toggleRatingModal', !this.modalOpened)
    },
  },
}
</script>
<style lang="scss" scoped>
.feedback-btn {
  --btn-border-color: rgba(255, 255, 255, 0.7);
}
</style>
